function getLists({ metadataId, category, page, size }, apiClient) {
  const route = apiClient.route`/libraries/${':librarySubdomain'}/lists`;
  return apiClient.get(route, { query: { metadataId, category, page, size } });
}

export default {
  getLists
};
